<template>
  <div style="width: 100%;height: 100%;text-align: center">
    <el-scrollbar style="height: 100%">
      <div style="font-size: 26px;font-weight: bolder;">主要完成单位情况表</div>
<!--      <el-button v-if="!isDisabled" style="float:right;margin-bottom: 15px;" size="small" type="primary" @click="onAdd">新增</el-button>-->
      <el-table :data="tableData" stripe highlight-current-row style="width: 100%;margin-top: 20px;">
        <el-table-column
          type="index"
          label="序号"
          width="60"
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="单位名称"
          width=""
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="rank"
          label="排名"
          width=""
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="representative"
          label="法定代表人"
          width=""
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone1"
          label="单位电话"
          width=""
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="roadgrade"
          label="操作"
          width="200"
          show-overflow-tooltip
          align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="onEdit(scope.row)">{{isDisabled ? '查看' : '编辑' }}</el-button>
<!--            <el-button v-if="!isDisabled" size="mini" type="danger" @click="onDelete(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px;float:left;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size='pageSize'
        layout="total, sizes, prev, pager, next, jumper"
        :total="total==0?0:parseInt(total)">
      </el-pagination>
    </el-scrollbar>

    <el-dialog class="dialogBig" title="主要完成单位" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="handleClose" width="60%" top="10vh">
      <el-scrollbar class="scroll_height" style="height: 530px;">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="单位名称" class="formList1" prop="name">
            <el-input :readonly="isDisabled" v-model="form.name" class="input_text" disabled></el-input>
          </el-form-item>
          <el-form-item label="排名" class="formList2" prop="rank">
            <el-input :readonly="isDisabled" v-model="form.rank" class="input_text" disabled @input="(val)=>{form.rank = val.replace(/[^\d:]/g, '')}" placeholder="请输入数字"></el-input>
          </el-form-item>
          <el-form-item label="法定代表人" class="formList2" prop="representative">
            <el-input :readonly="isDisabled" v-model="form.representative" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="所在地" class="formList2" prop="address">
            <el-input :readonly="isDisabled" v-model="form.address" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="单位性质" class="formList2" prop="characters">
            <el-input :readonly="isDisabled" v-model="form.characters" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="传真" class="formList2" prop="faxs">
            <el-input :readonly="isDisabled" v-model="form.faxs" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="邮政编码" class="formList2" prop="mails">
            <el-input :readonly="isDisabled" v-model="form.mails" class="input_text" maxlength="6" @input="(val)=>{form.mails = val.replace(/[^\d:]/g, '')}"></el-input>
          </el-form-item>
          <el-form-item label="通信地址" class="formList1" prop="massageaddress">
            <el-input :readonly="isDisabled" v-model="form.massageaddress" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="联系人" class="formList2" prop="linkman">
            <el-input :readonly="isDisabled" v-model="form.linkman" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="单位电话" class="formList2" prop="phone1">
            <el-input :readonly="isDisabled" v-model="form.phone1" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="移动电话" class="formList2" prop="phone2">
            <el-input :readonly="isDisabled" v-model="form.phone2" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" class="formList2" prop="email">
            <el-input :readonly="isDisabled" v-model="form.email" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label-width="150px" label="统一社会信用代码" class="formList3" prop="creditcode">
            <el-input :readonly="isDisabled" v-model="form.creditcode" class="input_text"></el-input>
          </el-form-item>
          <el-form-item label-width="350px" label="对本项目科技创新和推广应用情况的贡献（限600字)" class="formList1" prop="contribution">
            <el-input :readonly="isDisabled" v-model="form.contribution" class="input_text" type="textarea" :autosize="{minRows:6}" maxlength="600" show-word-limit></el-input>
          </el-form-item>
            <div style="width: 97%;height: 50px;float:left;text-align: left;border: 1px solid #dcdfe6;padding: 1%;"><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;声明：</strong>本单位同意完成单位排名，保证所提交的材料真实有效，且不存在任何违反《中华人民共和国保守国家秘密法》和《科学技术保密规定》等相关法律法规及侵犯他人知识产权的情形。本单位是独立法人机构。如有不符或虚假，本单位愿意承担相应责任并接受相应处理。如产生争议，保证积极配台调查处理工作。 <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本单位对项目完成人、项目完成单位及排序无异议。</div>
        </el-form>
      </el-scrollbar>
      <div v-if="!isDisabled" style="text-align: center;padding-top: 20px;border-top: 1px solid #E6E6E6">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose" style="margin-left: 24px">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from "../../js/utils";

  export default {
  name: "CompleteCompany_10",
    data() {
      return {
        createuserid: sessionStorage.getItem('createuserid'),
        isDisabled: sessionStorage.getItem('openWith')=='readOnly' ? true : false,
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        total: '',
        addOrEdit: '',
        dialogVisible: false,
        form: {
          pbcid: sessionStorage.getItem('pbcid'),
          name: '',
          rank: '',
          representative: '',
          address: '',
          characters: '',
          faxs: '',
          mails: '',
          massageaddress: '',
          linkman: '',
          phone1: '',
          phone2: '',
          email: '',
          creditcode: '',
          contribution: '',
        },
        rules: {
          name: {required: true, message: ' ', trigger: 'blur'},
          rank: {required: true, message: ' ', trigger: 'blur'},
          representative: {required: true, message: ' ', trigger: 'blur'},
          address: {required: true, message: ' ', trigger: 'blur'},
          characters: {required: true, message: ' ', trigger: 'blur'},
          faxs: {required: true, message: ' ', trigger: 'blur'},
          mails: {required: true, message: ' ', trigger: 'blur'},
          massageaddress: {required: true, message: ' ', trigger: 'blur'},
          linkman: {required: true, message: ' ', trigger: 'blur'},
          phone1: {required: true, message: ' ', trigger: 'blur'},
          phone2: {required: true, message: ' ', trigger: 'blur'},
          email: {required: true, message: ' ', trigger: 'blur'},
          creditcode: {required: true, message: ' ', trigger: 'blur'},
          contribution: {required: true, message: ' ', trigger: 'blur'},
        },
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.getData();
      },
      getData() {
        if (sessionStorage.getItem("pbcid") == undefined) {
          return
        }
        this.$axios({
          method: 'get',
          url: this.GLOBAL.URL + 'pingjiang/common/selectprojectunit',
          params: {
            pbcid: Number(sessionStorage.getItem('pbcid')),
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.tableData = resp.data.list;
            this.total = resp.data.total;
          } else {
            this.showFailMsg(resp.message)
          }
        })
      },
      onAdd() {
        this.addOrEdit = 'add';
        this.dialogVisible = true
      },
      onSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let url = '';
            url = this.addOrEdit=='add'?'pingjiang/user/addprojectunit':'pingjiang/user/updateprojectunit';
            this.$axios({
              method: 'post',
              url: this.GLOBAL.URL + url,
              data: this.form
            }).then((res) => {
              let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
              if (resp.code == 1000) {
                this.showSuccessMsg(resp.message);
                this.handleClose();
                this.getData()
              } else {
                this.showFailMsg(resp.message)
              }
            })
          } else {
            this.showNotifyError('请先完善完成单位信息！');
          }
        })
      },
      handleClose() {
        this.dialogVisible = false;
        Object.assign(this.$data.form, this.$options.data().form)
      },
      onEdit(row) {
        this.addOrEdit = 'edit';
        this.dialogVisible = true;
        this.$axios({
          method: 'get',
          url: this.GLOBAL.URL + 'pingjiang/common/selectprojectunitdetail',
          params: {
            unitid: row.unitid,
          }
        }).then(res => {
          let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
          if (resp.code == 1000) {
            this.form = resp.data;
          } else {
            this.showFailMsg(resp.message)
          }
        })
      },
      onDelete(row){
        this.$confirm('此操作将删除完成单位数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
            method: 'get',
            url: this.GLOBAL.URL + 'pingjiang/user/deleteprojectunit',
            params: {
              unitid: row.unitid,
            }
          }).then(res => {
            let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
            if (resp.code == 1000) {
              this.showSuccessMsg(resp.message);
              this.getData()
            } else {
              this.showFailMsg(resp.message)
            }
          })
        }).catch(() => {

        });
      }
    },
    created() {
      this.getData()
    },
    mounted() {
      if(sessionStorage.getItem('pbcid')==undefined){
        this.$message.error('请先填写项目基本情况表');
        this.$router.push({
          path:'/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'
        })
      }
    }
  }
</script>

<style scoped>
  .formList1 {
    float: left;
    width: 99%;
    display: inline-block;
  }
  .formList2 {
    float: left;
    width: 33%;
    display: inline-block;
  }
  .formList3 {
    float: left;
    width: 66%;
    display: inline-block;
  }

  .input_text {
    width: 100% !important;
  }

  /deep/ .el-scrollbar__wrap {
    overflow: hidden scroll;
    height: 100%;
  }

  .el-form-item{
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body{
    padding: 10px;
  }

  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;
    color: #727477;
  }
</style>




// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/CompleteCompany_10.vue